import { IoMdList, BiText, FaList, LuClock, MdOutlineNumbers, PiBracketsCurly, PiBracketsSquare, RxComponentBoolean, FiFileText } from '@/components/react-icons/main';

const dataTypeIcons = {
  string: BiText,
  number: MdOutlineNumbers,
  boolean: RxComponentBoolean,
  date: LuClock,
  lookup: FaList,
  list: IoMdList,
  array: PiBracketsSquare,
  object: PiBracketsCurly,
  file: FiFileText
};

export default dataTypeIcons;
